/** Ruta (patrón de App.tsx) → título legible para el contexto del chat. Orden: específicas primero. */
import type { PaginaContext } from '../../services/chat/uiContext';

const PAGES: Array<[string, string]> = [
  ['/animals/new', 'Carga de animales (sesión)'],
  ['/animals/historical/:id', 'Histórico de animal'],
  ['/animals/:caravana/pedigree', 'Pedigree de animal'],
  ['/animals/:caravana', 'Ficha de animal'],
  ['/animals', 'Mi Ganado'],
  ['/sesiones/:sessionCode/sigsa', 'SIGSA de la sesión'],
  ['/sesiones/:sessionCode', 'Ficha de sesión'],
  ['/sesiones', 'Sesiones de carga'],
  ['/ubicaciones/:id/stock-analysis', 'Análisis de stock de la ubicación'],
  ['/ubicaciones/:id/edit', 'Editar ubicación'],
  ['/ubicaciones/new', 'Nueva ubicación'],
  ['/ubicaciones/:id', 'Ficha de ubicación'],
  ['/ubicaciones', 'Ubicaciones'],
  ['/campos/:id/edit', 'Editar campo/unidad'],
  ['/campos/new', 'Nuevo campo/unidad'],
  ['/campos/:id', 'Ficha de campo/unidad'],
  ['/mapa', 'Mapa del campo'],
  ['/dashboard', 'Dashboard'],
  ['/statistics', 'Estadísticas'],
  ['/operaciones-compra-venta', 'Operaciones de compra/venta'],
  ['/administracion/stocks', 'Stock de insumos'],
  ['/administracion/gastos', 'Gastos'],
  ['/administracion/ingresos', 'Ingresos'],
  ['/administracion', 'Administración'],
  ['/reports', 'Reportes'],
  ['/herramientas', 'Herramientas'],
  ['/lluvias', 'Lluvias'],
  ['/configuraciones', 'Configuraciones'],
];

const toRegex = (pattern: string) => new RegExp(`^${pattern.replace(/:[A-Za-z]+/g, '[^/]+')}/?$`);
const COMPILED = PAGES.map(([ruta, titulo]) => ({ ruta, titulo, re: toRegex(ruta) }));

export function resolvePaginaWeb(pathname: string): PaginaContext {
  const hit = COMPILED.find((p) => p.re.test(pathname));
  return hit ? { ruta: hit.ruta, url: pathname, titulo: hit.titulo } : { ruta: pathname, url: pathname };
}
